var m = require('mithril');
var prop = require("mithril/stream");
var loadingModal = require('../layout/components/loadingModal');
var Model = require('../libs/Model');
var loadingModalORReport = Object.create(Model);


var modelOptions={}

loadingModalORReport.editDialogue = function (title, text, hideCloseIcon, showBars) {
  loadingModalORReport.text = text
  loadingModalORReport.showBars = showBars
  loadingModal.vm.hideCloseIcon(hideCloseIcon)
  loadingModal.vm.title(title);
  loadingModal.vm.body = loadingModalORReport.view, 
  loadingModal.vm.open(modelOptions);
  m.redraw();
}
loadingModalORReport.close = function (){
  loadingModal.vm.close();
  m.redraw();
}

loadingModalORReport.view = function () {
  return m('div', {role:'form'}, [
    m('label', loadingModalORReport.text + '  '),
    loadingModalORReport.showBars ? m('img.h1', {src: '/images/loading-bars.svg'}) : ''
])
}

module.exports = loadingModalORReport;